var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.35C0 2.85 2.85 0 6.35 0c3.5 0 6.35 2.85 6.35 6.35 0 3.5-2.85 6.35-6.35 6.35C2.85 12.7 0 9.85 0 6.35Zm1 0C1 9.3 3.4 11.7 6.35 11.7c2.95 0 5.35-2.4 5.35-5.35C11.7 3.4 9.3 1 6.35 1 3.4 1 1 3.4 1 6.35ZM5.85 7.5V3h1v4.5h-1Zm.501 2.21c.4 0 .73-.32.73-.72 0-.4-.33-.73-.73-.73-.4 0-.73.33-.73.73 0 .4.33.72.73.72Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.37d616beb43c602516aa400a9aa97353.svg";
export { ForwardRef as ReactComponent };